module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/n9GNJt/tc-custom/9781617451874.jpg?1737674163777",
      "alt": "This image is the cover for the book Festive Fall Quilts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Festive Fall Quilts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("21 quick and easy quilting projects to give your home a touch of whimsy in the fall, by the bestselling author of "), _c('i', [_vm._v("Playtime, Naptime, Anytime Quilts")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("From bestselling author Kim Schaefer comes this collection of 21 engaging piecing and applique projects for fall, including tried-and-true motifs such as pumpkins, sunflowers, acorns, turkeys, and autumn leaves. Plus, celebrate Halloween with spooky spiders, friendly bats, expressive jack-o-lanterns, and much more! Make projects in a variety of sizes, from tea towels and placemats to lap quilts and table runners. These quick and easy projects will brighten up your home for fall!"), _c('br'), _c('br'), _c('b', [_vm._v("Praise for "), _c('i', [_vm._v("Festive Fall Quilts")])]), _c('br'), _c('br'), _c('b', [_vm._v("“Sewers can harvest loads of fun decorating the house for autumn. The adorable appliqués in this book have a multitude of uses on place mats, runners, table toppers, wall quilts or fun towel embellishments.” —"), _c('i', [_vm._v("American Quilt Retailer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kim Schaefer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kim Schaefer Bio: Kim Schaefer is the founder of Little Quilt Company, a pattern company focused on designing a variety of small, fun-to-make projects. A best-selling author, Kim also designs fabric for Andover Fabrics. She lives with her family in Southeastern Wisconsin. littlequiltcompany.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0